/**
 * Device request headers (Phase 16C, design §6.6 / 16B B11). Kept free of other offline imports
 * so apiClient can read it without an import cycle.
 *
 * - Every authenticated request from a phone or tablet sends `X-Device-Class: MOBILE` (the server's
 *   mobile-only rule for visit start / end / cancel).
 * - While an enrolled device is unlocked it also sends `X-Device-Id`.
 */
import { detectDeviceClass, DeviceClass } from './platform/deviceClass';

let cachedClass: DeviceClass | null = null;
let enrolledDeviceId: string | null = null;

export const DeviceContext = {
  deviceClass(): DeviceClass {
    if (!cachedClass) cachedClass = detectDeviceClass();
    return cachedClass;
  },
  isMobile(): boolean {
    return this.deviceClass() === 'MOBILE';
  },
  enrolledDeviceId(): string | null {
    return enrolledDeviceId;
  },
  setEnrolledDeviceId(deviceId: string | null): void {
    enrolledDeviceId = deviceId;
  },
  /** Tests: forget the cached class. */
  reset(deviceClass: DeviceClass | null = null): void {
    cachedClass = deviceClass;
    enrolledDeviceId = null;
  },
};

export function deviceHeaders(): Record<string, string> {
  if (!DeviceContext.isMobile()) return {};
  const headers: Record<string, string> = { 'X-Device-Class': 'MOBILE' };
  const id = DeviceContext.enrolledDeviceId();
  if (id) headers['X-Device-Id'] = id;
  return headers;
}
